import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';

import plus from '../../images/managers/plus.svg';
import comment from '../../images/managers/comment.svg'
import CommentsModal from '../comments/CommentsModal';

const StyledFloatButton = styled.div`
    .rtf {
      &--ab__c {
        top: -25px;
        margin: 0;
        padding: 0;
        button {
          width: 70px;
          height: 70px;
          margin: 0;
          background-image: linear-gradient(87.88deg, #6B92FF 0%, #8764FF 100%);
        }
        .right {
          right: 25px;
          display: block;
          padding: 15px 60px 15px 20px;
          background: #fff;
          font-size: 15px;
          font-weight: bold;
          color: var(--bllink-purple);
          border: 1px solid #6F8BFF;
          border-radius: 50px;
          &.always-show {
            opacity: 1;
          }
        }
      }
    }
`;

export default function FloatingButton({buildingId}) {
    const {t} = useTranslation();

    const [commentsModalOpened, setCommentsModalOpened] = useState(false);

    return (
        <>
            <StyledFloatButton>
                <Fab
                    mainButtonStyles={{
                        backgroundImage: 'linear-gradient(87.88deg, #6B92FF 0%, #8764FF 100%)',
                        width: '70px',
                        height: '70px',
                    }}
                    style={{
                        bottom: 25,
                        right: 25,
                        padding: 0,
                        margin: 0
                    }}
                    icon={<img src={plus} alt="plus" />}
                    event={'click'}
                >
                    <Action
                        text={t('comments.add')}
                        onClick={() => setCommentsModalOpened(true)}
                    >
                        <img src={comment} alt="comment" />
                    </Action>
                </Fab>
            </StyledFloatButton>
            <CommentsModal
                show={commentsModalOpened}
                buildingId={buildingId}
                onModalHide={() => setCommentsModalOpened(false)}
                prefetchComments={false}
            />
        </>
    );
}
